// IndexedDB utility functions for asset management
const ASSETS_DB_NAME = 'perkins-filter-benefits-db';
const VIDEO_STORE_NAME = 'videos';
const IMAGE_STORE_NAME = 'images';
const PDF_STORE_NAME = 'pdfs';
const FONT_STORE_NAME = 'fonts';
const DB_VERSION = 1;

function openAssetsDB() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(ASSETS_DB_NAME, DB_VERSION);
        
        request.onerror = (event) => {
            reject(event.target.error);
        };
        
        request.onsuccess = (event) => {
            resolve(event.target.result);
        };
        
        request.onupgradeneeded = (event) => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains(VIDEO_STORE_NAME)) {
                db.createObjectStore(VIDEO_STORE_NAME, { keyPath: 'url' });
            }
            if (!db.objectStoreNames.contains(IMAGE_STORE_NAME)) {
                db.createObjectStore(IMAGE_STORE_NAME, { keyPath: 'url' });
            }
            if (!db.objectStoreNames.contains(PDF_STORE_NAME)) {
                db.createObjectStore(PDF_STORE_NAME, { keyPath: 'url' });
            }
            if (!db.objectStoreNames.contains(FONT_STORE_NAME)) {
                db.createObjectStore(FONT_STORE_NAME, { keyPath: 'url' });
            }
        };
    });
}

function getAssetFromDB(storeName, url) {
    return openAssetsDB().then(db => {
        return new Promise((resolve, reject) => {
            try {
                const transaction = db.transaction([storeName], 'readonly');
                const store = transaction.objectStore(storeName);
                
                const request = store.get(url);
                
                request.onsuccess = (event) => {
                    if (event.target.result) {
                        resolve(event.target.result.blob);
                    } else {
                        resolve(null);
                    }
                };
                
                request.onerror = (error) => {
                    reject(error);
                };
                
                transaction.oncomplete = () => db.close();
            } catch (error) {
                reject(error);
            }
        });
    });
}

function getImageFromDB(url) {
    return getAssetFromDB(IMAGE_STORE_NAME, url)
    .then(imageBlob => {
        if (imageBlob) {
            return imageBlob;
        }
    })
    .catch(error => {
        return null;
    });
  }

function getPdfFromDB(url) {
    // First, try with the original URL
    return getAssetFromDB(PDF_STORE_NAME, url)
        .then(pdfBlob => {
            if (pdfBlob) {
                return pdfBlob;
            }
        })
        .catch(error => {
            return null;
        });
}

function getVideoFromDB(url) {
    return getAssetFromDB(VIDEO_STORE_NAME, url)
    .then(videoBlob => {
        if (videoBlob) {
            // Validate the blob
            if (!videoBlob.type || videoBlob.size === 0) {
                // console.warn('Invalid video blob from IndexedDB:', url, 
                //     'Type:', videoBlob.type || 'missing', 
                //     'Size:', videoBlob.size);
                
                // Try to ensure a proper MIME type if missing
                if (!videoBlob.type && videoBlob.size > 0) {
                    // Create a new blob with proper MIME type based on file extension
                    const fileExtension = url.split('.').pop().toLowerCase();
                    let mimeType = 'video/mp4'; // Default
                    
                    if (fileExtension === 'webm') {
                        mimeType = 'video/webm';
                    } else if (fileExtension === 'ogg' || fileExtension === 'ogv') {
                        mimeType = 'video/ogg';
                    }
                    
                    try {
                        const validBlob = new Blob([videoBlob], { type: mimeType });
                        console.log('Created new blob with proper MIME type:', mimeType);
                        return validBlob;
                    } catch (e) {
                        console.error('Failed to create new blob with MIME type:', e);
                    }
                }
            } else {
                // console.log('Valid video blob from IndexedDB:', url, 
                //     'Type:', videoBlob.type, 
                //     'Size:', videoBlob.size);
            }
            return videoBlob;
        }
        return null; // Explicitly return null when no blob is found
    })
    .catch(error => {
        console.error('Error in getVideoFromDB:', error);
        return null;
    });
}

function getJSONFromDB(url) {
    return getAssetFromDB(IMAGE_STORE_NAME, url)
    .then(jsonBlob => {
        if (jsonBlob) {
            return jsonBlob.text().then(text => {
                try {
                    return JSON.parse(text);
                } catch (e) {
                    console.error('Error parsing JSON from IndexedDB:', e);
                    return null;
                }
            });
        }
        return null;
    })
    .catch(error => {
        console.error('Error retrieving JSON from IndexedDB:', error);
        return null;
    });
}

// Export the functions and constants
export {
    ASSETS_DB_NAME,
    VIDEO_STORE_NAME,
    IMAGE_STORE_NAME,
    PDF_STORE_NAME,
    FONT_STORE_NAME,
    DB_VERSION,
    openAssetsDB,
    getAssetFromDB,
    getPdfFromDB,
    getVideoFromDB,
    getImageFromDB,
    getJSONFromDB
};